module.exports = {
	config: {
		environmentDependent: true,
		collapsable: true,
		collapsableTurnedOn: true,
		border: false
	},

	model: {
		additionalClasses: [],
		open: true,
		height: 0
	},

	events: {
		toggle: {
			type: 'click',
			selector: '.trigger',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();
				event.data.component.toggle();
			}
		}
	},

	methods: {
		/**
		 * this function has to return true if the environment dependent refresh should be performed.
		 *
		 * @param   activeEnvironment               {} - active environment
		 * @param   newEnvironment                  {} - new environment
		 * @param   serverKnownEnvironment          {} - environment known by the server
		 * @param   initialExecution                boolean - is this the initial execution
		 * @param   externalDrivenCall              boolean - e.g., browser resize -> true, ibt-grid-style-change -> false
		 * @param   environmentUpdateByParent       boolean - has a parent of mine decided to refresh and already updated by own activeEnvironment
		 * @returns boolean
		 */
		environmentRefreshNecessary: function(activeEnvironment, newEnvironment, serverKnownEnvironment, initialExecution, externalDrivenCall, environmentUpdateByParent){
			return activeEnvironment.style !== newEnvironment.style;
		},

		onEnvironmentUpdated: function(){
			if((this.config.collapsable = (this.config.collapsableTurnedOn && this.activeEnvironment.style === 'mobile'))){
				this.config.border = true;
				this.model.open = false;
			}

			this.sanitizeClasses();
			this.prepareMeta();
			this.refresh();
		},

		sanitizeClasses: function(){
			this.model.additionalClasses = [];
			if(this.config.border) 		this.model.additionalClasses.push('border');
			if(this.config.collapsable) this.model.additionalClasses.push('collapsable');
			if(this.model.open) 		this.model.additionalClasses.push('open');
		},

		prepare: function(){
			// if((this.config.collapsable = (this.config.collapsableTurnedOn && this.activeEnvironment.style === 'mobile'))){
			// 	this.config.border = true;
			// }

			this.sanitizeClasses();
			this.prepareMeta();
		},

		prepareMeta: function(){},

		open: function(){
			if(this.config.collapsable){
				if(!this.model.height && this.model.$collapsable.length > 0){
					this.$.addClass('open').css('visibility', 'invisible');
					this.model.height = this.model.$collapsable.outerHeight();
					this.$.removeClass('open').css('visibility', 'visible');
				}

				if(!this.model.closedHeight){
					this.model.closedHeight = this.model.$collapsable.outerHeight();
					TweenMax.set(
						this.model.$collapsable,
						{
							height: this.model.closedHeight
						}
					)
				}
				this.model.open = true;
				this.$.addClass('open');
				TweenMax.to(
					this.model.$collapsable,
					0,
					{
						height: this.model.height
					}
				);
			}
		},

		close: function(){
			if(this.config.collapsable) {
				this.model.open = false;
				this.$.removeClass('open');
				this.model.$collapsable.css('height', 'unset !important');
			}
		},

		toggle: function(){
			if(this.config.collapsable) {
				if (this.model.open) 	this.close();
				else 					this.open();
			}
		}
	},

	hooks: {
		attach: function($element, options){
			this.model.$collapsable = $element;
			if(!$element.is('.collapsable')) this.model.$collapsable = $element.find('.collapsable');

			// if(!this.model.height && this.config.collapsable && this.model.$collapsable.length > 0){
				// this.$.addClass('open');
				// this.model.height = this.model.$collapsable.outerHeight();
				// this.$.removeClass('open');
			// }
		}
	}
};